export const WORKOS_WIDGETS_FONT_FAMILY =
  "Favorit, Inter, system-ui, Avenir, Helvetica, Arial, sans-serif";
